import { useRef, useState } from "react";
import { CourselCard } from "../LandingPage/MustTryComponent";

export function ManualImageCarousel({
  cards,
  CardDesign,
  paddingLeft,
  paddingRight,
}) {
  const sliderRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handlePointerDown = (e) => {
    const slider = sliderRef.current;
    setIsDown(true);
    setStartX(e.pageX - slider.offsetLeft);
    setScrollLeft(slider.scrollLeft);
  };

  const handlePointerLeave = () => setIsDown(false);
  const handlePointerUp = () => setIsDown(false);

  const handlePointerMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const slider = sliderRef.current;
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1;
    slider.scrollLeft = scrollLeft - walk;
  };
  console.log({ cards });

  return (
    <div
      className="no-scrollbar"
      style={{
        overflowX: "scroll",
        overflowY: "hidden",
        position: "relative",
        width: "100%",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div
        ref={sliderRef}
        onMouseDown={handlePointerDown}
        onMouseLeave={handlePointerLeave}
        onMouseUp={handlePointerUp}
        onMouseMove={handlePointerMove}
        className="no-scrollbar"
        style={{
          display: "flex",
          width: "100%",
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          gap: "16px",
          paddingRight: paddingRight ?? "250px",
          paddingLeft: paddingLeft ?? "0",
          // paddingLeft: "50px",
        }}
      >
        {cards?.map((card, i) => (
          <div
            key={card?.id ?? i}
            style={{
              flexShrink: 0,
              maxWidth: "445px",
              // scrollSnapAlign: "start",
            }}
          >
            <div
              style={{
                overflow: "hidden",
              }}
            >
              {CardDesign ? (
                <CardDesign card={card} />
              ) : (
                <CourselCard
                  image={card?.src}
                  name={card?.name}
                  storeLink={process.env.REACT_APP_PRASADAM_STORE_LINK}
                />
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Global scrollbar hide patch */}
      <style>
        {`
      .no-scrollbar {
        -ms-overflow-style: none;       /* IE/Edge */
        scrollbar-width: none;          /* Firefox */
      }
      .no-scrollbar::-webkit-scrollbar {
        display: none;                  /* Chrome/Safari/WebKit */
      }
    `}
      </style>
    </div>
  );
}
